import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { createElement } from 'react';
import { forwardRefWithAs } from '@stacks/ui-core';
import { Box } from '../box/index.esm.js';

var Grid = /*#__PURE__*/forwardRefWithAs(function (props, ref) {
  return /* @__PURE__ */createElement(Box, _extends({
    display: "grid",
    ref: ref
  }, props));
});

export { Grid };
//# sourceMappingURL=index.esm.js.map
